import { urls } from '@/config/assets';
import AssetService from '@/services/AssetService';
import { OrthographicCamera } from '@react-three/drei';

export const BeerScore = ({ stage = 0 }) => {
  const score = useScore();

  const [t_score_1, t_score_2, t_score_3] = useAsset([
    urls.t_score_1,
    urls.t_score_2,
    urls.t_score_3,
  ]);

  const textures = [t_score_1, t_score_2, t_score_3];

  const refSprite = useRef();

  useEffect(() => {
    refSprite.current.frame = Math.min(score, SCORE_LIMIT);
  }, [score]);

  // const { width, height } = useThree((state) => state.viewport);
  const { width, height } = useWindowSize();

  if (score == SCORE_LIMIT) {
    AssetService.getAsset(`s_empty_${stage}`).play();
  }

  const position =
    height > width
      ? [width * (-0.5 - 0.25), height * (0.5 + 0.28), 0]
      : [width * -0.3, 0, 0];

  console.log(width, height);

  useEffect(() => {
    if (score == SCORE_LIMIT) {
      setTimeout(() => {
        AssetService.getAsset(`s_collect_complete`).play();
      }, 500);
    }
  }, [score]);

  return (
    <>
      <OrthographicCamera
        makeDefault
        position={[0, 0, 10]}
      />
      <group
        name="beer-score"
        position={[width * -0.5 + 50, height * 0.5 - 70, 0]}
      >
        <mesh scale={[1, -1, 1]}>
          <planeGeometry args={[100, 100]} />
          <GBufferMaterial
            transparent
            depthTest={false}
          >
            <MaterialModuleSpriteAnimated
              ref={refSprite}
              map={textures[stage]}
              rows={2}
              cols={4}
              frames={6}
              frame={0}
            />
            <MaterialModuleAlphaTest />
          </GBufferMaterial>
        </mesh>
      </group>
    </>
  );
};
